/**
 * Task Formatter.
 * @param {*} value
 * @param {object} row
 * @returns {string}
 */
window.taskFormatter = function(value, row) {
    let html = '';
    if (can('admin.tasks.show') && row.task_id) {
        html += '<a href="/admin/tasks/show/'+row.task_id+'">';
        html += value;
        html += '</a>';
    } else if (can('tuijncode.tasks') && row.task_id) {
        html += '<a href="/tuijncode/tasks/show/'+row.task_id+'">';
        html += value;
        html += '</a>';
    } else {
        html += value;
    }
    return html;
}
